<div
    class="patient-header-container flex justify-content-between align-items-center pb-3 border-bottom-1 surface-border">
    <div class="left-section overflow-hidden" style="flex: 1; min-width: 0">
        <div class="flex align-items-center text-900 text-2xl font-medium mb-1">
            <span class="font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis" [title]="name">{{ name
                | uppercase }}</span>
            <span class="text-500 mx-2 flex-shrink-0">|</span>
            <span class="white-space-nowrap flex-shrink-0">{{ ageAtVisit | number:'1.0-2' }} years old</span>
        </div>
        <div class="text-700 text-lg white-space-nowrap overflow-hidden text-overflow-ellipsis" [title]="title">{{ title
            }}</div>
    </div>

    <div class="right-section text-right text-sm text-500 flex-shrink-0 ml-3">
        <div>Last Visit: <span class="text-700">{{ dateOfLastVisit | date:'d MMM yyyy' }}</span></div>
        <div class="mt-1">Generated: {{ todaysDate | date:'d MMM yyyy' }}</div>
    </div>
</div>